"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _get = _interopRequireDefault(require("transmute/get"));

var _UserProfile = _interopRequireDefault(require("./UserProfile"));

var defaults = {
  userProfile: new _UserProfile.default(),
  portalId: null,
  userId: null,
  isSalesStarter: false,
  calendarProvider: null
};

var PublicMeetingsUser =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(PublicMeetingsUser, _Record);

  function PublicMeetingsUser() {
    (0, _classCallCheck2.default)(this, PublicMeetingsUser);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PublicMeetingsUser).apply(this, arguments));
  }

  (0, _createClass2.default)(PublicMeetingsUser, null, [{
    key: "from",
    value: function from(json) {
      return new PublicMeetingsUser((0, _extends2.default)({}, json, {
        isSalesStarter: json.hasSalesStarterFeatures || json.isSalesStarter || json.salesPro || false,
        userProfile: new _UserProfile.default(json.userProfile)
      }));
    }
  }, {
    key: "fromBookInfo",
    value: function fromBookInfo(bookInfo) {
      return (0, _get.default)('meetingsUser', bookInfo.allUsersBusyTimes.find(function (userBusyTimes) {
        return userBusyTimes.meetingsUser.userId === bookInfo.userId;
      }));
    }
  }]);
  return PublicMeetingsUser;
}((0, _immutable.Record)(defaults));

exports.default = PublicMeetingsUser;
module.exports = exports.default;